// extracted by mini-css-extract-plugin
module.exports = {"host":"ViewHost_host__3D1z0","title":"ViewHost_title__24Wfr","close":"ViewHost_close__2WzKo","content":"ViewHost_content__RmzE6"};